const bedc = [
	'bedc:principal:read:{organizationId}',

	'bedc:principal:lookup',
	'bedc:principal:list',

	'bedc:principal:search',

	'bedc:principal:create:{organizationId}',

	'bedc:principal:update:{organizationId}',

	'bedc:principal:delete:{organizationId}',
] as const;

export default [...bedc] as const;
